import { Controller } from "@hotwired/stimulus"

// Controls select all/deselect all and search functionality for the filter dialog.
// Uses dynamic targets based on data-filter-group attribute for flexible checkbox list handling.
export default class extends Controller {
  static targets = ["checkbox", "item"]

  // Select all checkboxes in a specific group
  selectAll(event) {
    event.preventDefault()
    const group = event.currentTarget.dataset.group
    this.checkboxTargets
      .filter((checkbox) => checkbox.dataset.group === group)
      .forEach((checkbox) => {
        checkbox.checked = true
      })
  }

  // Deselect all checkboxes in a specific group
  deselectAll(event) {
    event.preventDefault()
    const group = event.currentTarget.dataset.group
    this.checkboxTargets
      .filter((checkbox) => checkbox.dataset.group === group)
      .forEach((checkbox) => {
        checkbox.checked = false
      })
  }

  // Search/filter items in a specific group
  search(event) {
    const query = event.target.value.toLowerCase().trim()
    const group = event.target.dataset.group

    this.itemTargets
      .filter((item) => item.dataset.group === group)
      .forEach((item) => {
        const name = (item.dataset.name || "").toLowerCase()
        item.classList.toggle("hidden", query && !name.includes(query))
      })
  }
}
